import { render } from "./Broker.vue?vue&type=template&id=5948db18&scoped=true"
import script from "./Broker.vue?vue&type=script&lang=js"
export * from "./Broker.vue?vue&type=script&lang=js"

import "./Broker.vue?vue&type=style&index=0&id=5948db18&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5948db18"

export default script